import React, { PropsWithChildren, useId } from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import { ValidationError } from 'yup';
import clsx from 'clsx';

interface ComponentProps {
  label?: string | object;
  type: string;
  className?: string;
  InputGroup?: boolean;
  classNameInput?: string;
  classNameWrapper?: string;
  description?: string | JSX.Element;
  placeholder?: string;
  value?: any;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => unknown;
  required?: boolean;
  descriptionOnClick?: () => unknown;
  errors?: ValidationError[];
  validationPath?: string;
}

const InputWrapper: React.FC<PropsWithChildren<ComponentProps>> = ({
  type,
  value,
  className,
  label,
  required,
  description,
  placeholder,
  InputGroup,
  errors = [],
  validationPath = '',
  classNameWrapper,
  onChange,
  children,
}) => {
  const { t } = useTranslation('common');

  const classes = clsx('input', className);
  const classesWrapper = clsx(classNameWrapper);

  const id = useId().replace(/:/g, '');

  const error = errors.find(e => e.path === validationPath);

  return (
    <div className={classesWrapper ? 'p-field ' + classesWrapper : 'p-field p-col-12 p-md-8 p-lg-4'}>
      {label && (
        <label className="inputLabel p-d-block" htmlFor={id}>
          <strong>{`${label}${required ? '*' : ''}`}</strong>
        </label>
      )}

      <div className="p-inputgroup">
        <InputText name={id} type={type} id={id} placeholder={placeholder} className={classes} value={value} onChange={onChange} />
        {InputGroup && (
          <span className="p-inputgroup-addon">
            <i className="pi pi-user"></i>
          </span>
        )}
      </div>

      {description && (
        <small className="p-d-block">
          {description}
          <span className="text-blue" style={{ marginLeft: '.5rem' }}>
            {t('wayPage.form.labelEnterManuallyAddresses')}
          </span>
        </small>
      )}

      {error && <div className="p-invalid-feedback">{t(`validation.${error.type}`)}</div>}

      {children}
    </div>
  );
};

export default InputWrapper;
